const request = require('request');
const config = require('./config');

const post = (token, formData) => {
  return new Promise((resolve, reject) => {
    const url = `${config.URL_BACKEND}/compliance`;
    const response = fetch(url, {
      headers: {
        'User-Token': token
      },
      method: 'POST',
      body: formData
    });
    resolve(response);
  });
};

const put = (token, formData, id) => {
  return new Promise((resolve, reject) => {
    const url = `${config.API_NODE}/documents/compliance/${id}`;
    
    const response = fetch(url, {
      headers: new Headers({
        authorization: config.API_TOKEN,
        'x-api-key': config.GATEWAY_API_KEY,
        'usertoken': token,
        'userfunctionkey': '19ca14e7ea6328a42e0eb13d585e4c22'
      }),
      method: 'PUT',
      body: formData
    });
    resolve(response);
  });
};

const getAll = (token, personId) => {
  const query = `query documents {
    DocumentsList(personId: ${personId}) {
      complianceId
      complianceName
      complianceDescription
      startDate
      endDate
      signatureDate
      isPending
    }
  }`;

  return new Promise((resolve, reject) => {
    request({
      headers: {
        'authorization': config.API_TOKEN,
        'x-api-key': config.GATEWAY_API_KEY,
        'usertoken': token,
        'userfunctionkey': '1c383cd30b7c298ab50293adfecb7b18',
        'content-type': 'application/json'
      },
      url: config.API_GRAPHQL,
      method: 'POST',
      body: JSON.stringify({
        query: query
      })
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({ err: err, res: res, body: body });
    });
  });
};

const getOne = (token, id) => {
  return new Promise((resolve, reject) => {
    request({
      headers: {
        'User-Token': token
      },
      uri: `${config.URL_BACKEND}/compliance/${id}`,
      method: 'GET',
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({ err: err, res: res, body: body });
    });
  });
};

const remove = (token, id) => {
  return new Promise((resolve, reject) => {
    request({
      headers: {
        'User-Token': token
      },
      uri: `${config.URL_BACKEND}/compliance/${id}`,
      method: 'DELETE',
    }, (err, res, body) => {
      if (err){
        console.error(err);
        return reject(err);
      }
      resolve({ err: err, res: res, body: body });
    });
  });
};

const qtyDocumentsPending = (token, id) => {
  return new Promise((resolve, reject) => {
    request({
      headers: {
        'Authorization': config.API_TOKEN,
        'x-api-key': config.GATEWAY_API_KEY,
        'usertoken': token,
        'userfunctionkey': '1c383cd30b7c298ab50293adfecb7b18'
      },
      uri: `${config.API_NODE}/documents/qtyDocumentsPending?personId=${id}`,
      method: 'GET',
      timeout: 3000
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({ err: err, res: res, body: body });
    });
  });
};

const signDocument = (token, requestBody) => {
  return new Promise((resolve, reject) => {
    request({
      headers: {
        'Authorization': config.API_TOKEN,
        'x-api-key': config.GATEWAY_API_KEY,
        'usertoken': token,
        'userfunctionkey': '1c383cd30b7c298ab50293adfecb7b18',
        'content-type': 'application/json'

      },
      uri: `${config.API_NODE}/documents/signDocumentCompliance`,
      method: 'POST',
      timeout: 3000,
      body: requestBody
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({ err: err, res: res, body: body });
    });
  });
};

const getDocument = (token, complianceId) => {
  return new Promise((resolve, reject) => {
    request({
      headers: {
        'Authorization': config.API_TOKEN,
        'x-api-key': config.GATEWAY_API_KEY,
        'usertoken': token,
        'userfunctionkey': '1c383cd30b7c298ab50293adfecb7b18',

      },
      uri: `${config.API_NODE}/documents/document?complianceId=${complianceId}`,
      method: 'GET',
      timeout: 3000,
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({ err: err, res: res, body: body });
    });
  });
};

module.exports = {
  post: post,
  put: put,
  remove: remove,
  getAll: getAll,
  getOne: getOne,
  qtyDocumentsPending,
  signDocument,
  getDocument
}